import {Component, OnDestroy, OnInit} from '@angular/core';
import {IShopUser} from "../../session/customer-models";
import {ICart} from "../../cart/cart-models";
import {AutoOrder} from "../../autoorder/auto-order-models";
import {IShareList} from "../../social/social-models";
import {BaseComponent} from "../../base.component";
import {UserService} from "../user.service";
import {LoggerService} from "../logger.service";
import {Constants} from "../../constants";
import {Subscription} from "rxjs";
import {Util} from "../../util/util";
import uxPackage from '@usana/ux/package.json';
import {PaymentCacheService} from "../../../checkout/payment/payment-cache.service";
import {CartCacheService} from "../../cart/cart-cache.service";
import {AutoOrderCacheService} from "../../ao-cart/ao-cache.service";
import {ShareListCacheService} from "../../social/share-list/share-list-cache.service";

@Component({
    selector: 'debug',
    templateUrl: './debug.component.html',
    styleUrls: ['./debug.component.scss'],
    standalone: false
})
export class DebugComponent extends BaseComponent implements OnInit, OnDestroy {

    debug: boolean = false;
    user: IShopUser;
    cart: ICart;
    autoOrders: AutoOrder[];
    expanded: boolean = true;
    shareLists: IShareList[];
    showCustomerDebug: boolean = false;
    showCartDebug: boolean = false;
    showAoDebug: boolean = false;
    showShareList: boolean = false;
    uxLibraryVersion: string = uxPackage.version;

    subscription: Subscription;

    constructor(private userService: UserService,
                loggerService: LoggerService,
                private cartCacheService: CartCacheService,
                private aoCacheService: AutoOrderCacheService,
                private shareListCacheService: ShareListCacheService,
                private paymentCacheService: PaymentCacheService) {
        super(userService, loggerService);
        this.subscription = this.userService.getShopUser().subscribe((user: IShopUser) => this.user = user);
        this.subscription.add(this.cartCacheService.cartSubject.subscribe((cart: ICart) => this.cart = cart));
        this.subscription.add(this.aoCacheService.autoOrdersSubject.subscribe((autoOrders: AutoOrder[]) => this.autoOrders = autoOrders));
        this.subscription.add(this.shareListCacheService.shareListsSubject.subscribe(data => this.shareLists = data));
    }

    ngOnInit(): void {
        this.checkDebug();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    get usingOldCheckoutOverride(): string {
        if (!this.inProd()) {
            return sessionStorage.getItem(Constants.USE_OLD_CHECKOUT) ?? "false";
        } else {
            return "Disabled in Prod";
        }
    }

    get isFormValidationDisabled(): string {
        if (!this.inProd()) {
            return sessionStorage.getItem(Constants.DISABLE_FORM_VALIDATION) ?? "false";
        } else {
            return "Disabled in Prod";
        }
    }

    get showKcpInformation(): boolean {
        return this.user?.country == 'KR';
    }

    checkDebug() {
        this.debug = Util.getHref().search("/?debug") >= 0 || Util.getHref().search("/&debug") >= 0;
    }

    stopTranslating() {
        sessionStorage.setItem(Constants.STOP_TRANSLATING, "true");
        window.location.reload();
    }

    startTranslating() {
        sessionStorage.removeItem(Constants.STOP_TRANSLATING);
        window.location.reload();
    }

    inProd() {
        return Util.getHref().includes("usana.com") || Util.getHref().includes("baoying.com");
    }

    oldCheckoutOverride() {
        //not for prod, we ain't that crazy
        if (!this.inProd()) {
            sessionStorage.setItem(Constants.USE_OLD_CHECKOUT, "true");
        }
    }

    removeOldCheckoutOverride() {
        sessionStorage.removeItem(Constants.USE_OLD_CHECKOUT);
    }

    disableFormValidation() {
        //not for prod, we ain't that crazy this time either.
        if (!this.inProd()) {
            sessionStorage.setItem(Constants.DISABLE_FORM_VALIDATION, "true");
        }
    }

    enableFormValidation() {
        sessionStorage.removeItem(Constants.DISABLE_FORM_VALIDATION);
    }

    kcpReconciliationSuffixChanged(event: Event) {
        const value = (event.target as HTMLInputElement)?.value;
        if (!value || value.trim() == '') {
            this.paymentCacheService.kcpReconciliationSuffixSubject.clear();
        } else {
            this.paymentCacheService.kcpReconciliationSuffixSubject.set(value);
        }
    }

    get kcpReconciliationSuffix() {
        return this.paymentCacheService.kcpReconciliationSuffixSubject.get();
    }
}
